import React, { useRef } from 'react'
import { Modal, message } from 'antd'
import { QRCodeCanvas } from 'qrcode.react'

const MyQrcode = (props) => {
  const accessAddress = (props.data && props.data.accessAddress) || ''
  const qrcodeRef = useRef(null)

  const handleCopy = () => {
    if (!accessAddress) {
      message.warning('暂无可复制的访问地址！')
      return
    }

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(accessAddress).then(() => {
        message.success('学生访问地址已复制！')
      }).catch(err => {
        console.error('复制失败: ', err)
        message.error('复制失败，请手动复制！')
      })
    } else {
      const textarea = document.createElement('textarea')
      textarea.value = accessAddress;
      document.body.appendChild(textarea)
      textarea.select();
      try {
        document.execCommand('copy');
        message.success('学生访问地址已复制！')
      } catch (err) {
        console.error('复制失败: ', err)
        message.error('复制失败，请手动复制！')
      }
      document.body.removeChild(textarea)
    }
  }

  const handleDownload = () => {
    if (!accessAddress) {
      message.warning('暂无可保存的二维码！')
      return
    }

    const canvas = qrcodeRef.current && qrcodeRef.current.querySelector('canvas')
    if (!canvas) {
      message.error('二维码生成失败，请重新打开！')
      return
    }

    try {
      const link = document.createElement('a')
      link.href = canvas.toDataURL('image/png')
      link.setAttribute('download', 'qrcode.png')
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    } catch (err) {
      console.error('保存二维码失败: ', err)
      message.error('保存二维码失败！')
    }
  }

  return (
    <Modal 
      width={400}
      title="查看学生访问地址"
      open={props.isOpen}
      onCancel={props.isCancel}
      footer={false}>

      <div className='general-qrcode-container'>
        <div className='general-qrcode' ref={qrcodeRef}>
          {accessAddress ? (
            <QRCodeCanvas
              value={accessAddress}
              size={220}
              level='M'
              bgColor='#FFFFFF'
              fgColor='#000000'
              includeMargin
              style={{ width: '100%', height: '100%' }}
            />
          ) : (
            <div className='general-qrcode-empty'>暂无访问地址</div>
          )}
        </div>

        <div className='general-qrcode-buttonBox'>
          <div className='general-qrcode-button1' onClick={ handleCopy }>
            <p>复制链接</p>
          </div>
          <div className='general-qrcode-button2' onClick={ handleDownload }>
            <p>保存图片</p>
          </div>
        </div>
      </div>

    </Modal>
  )
}

export default MyQrcode
